import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import format from 'date-fns/format';
import { Table } from 'reactstrap';
import Pagination from 'components/molecules/pagination';
import common from 'constants/common';
import withLoaderTable from 'components/organisms/withLoader/withLoaderTable';
import SmsFromIcon from 'components/atoms/icons/smsFromIcon';
import SmsToIcon from 'components/atoms/icons/smsToIcon';

const Messages = ({ patientGuid, isCcmPanel }) => {
  const loading = useSelector((state) => state.loading.effects.sms.getMessages);
  const messages = useSelector((state) => state.sms.messages);
  const dates = useSelector((state) => state.sms.dates);

  const {
    sms: { setPageSms, getMessages, setTimeRange },
  } = useDispatch();

  useEffect(() => {
    if (dates) {
      setTimeRange({ dates });
      getMessages({ patientGuid, isCcmPanel });
    }
  }, [patientGuid, dates]);

  const setPage = (pageOffset) => {
    setTimeRange({ dates });
    setPageSms({ pageOffset });
    getMessages({ patientGuid, isCcmPanel });
  };

  const smsIcon = (direction) => {
    if (direction === '90105' || direction === '78616') {
      return <SmsToIcon />;
    }
    return <SmsFromIcon />;
  };

  return (
    <div className="general-comments sms">
      <Table borderless border="0" cellSpacing="0" cellPadding="0">
        <thead>
          <tr>
            <th colSpan="3">
              <Pagination
                title="SMS Message Log"
                page={messages.page}
                total={messages.totalCount}
                itemsPerPage={messages.pageStep}
                pageTotal={messages.data.length}
                handlePrevClick={() => setPage(-1)}
                handleNextClick={() => setPage(+1)}
                handleFirstClick={() => setPage(-(messages.page - 1))}
                handleLastClick={() =>
                  setPage(
                    Math.ceil(messages.totalCount / messages.pageStep) -
                      messages.page,
                  )
                }
                loading={loading}
              />
            </th>
          </tr>
        </thead>
        {withLoaderTable(
          loading,
          <tbody>
            {messages.data.map((message) => (
              <tr key={message.guid}>
                <td className="col-8 comment">
                  <strong>{message.createdBy}</strong>
                  <div className="comment__message">{message.message}</div>
                </td>
                <td className="col-4 info">
                  {smsIcon(message.direction)}
                  <span>
                    {message.createdAt
                      ? format(
                          new Date(message.createdAt),
                          common.dateFormats.short,
                        )
                      : ''}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>,
        )}
      </Table>
    </div>
  );
};

Messages.propTypes = {
  patientGuid: PropTypes.string.isRequired,
  isCcmPanel: PropTypes.bool,
};

export default Messages;
